module.exports = __webpack_public_path__ + "img/CDN-Header.06bfce0.svg";